import React, { Fragment } from 'react'
import { i18nTranslate } from 'src/utils'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import {
  APPConfig,
  REGION_SELECTOR_URL,
  REGION_SELECTOR_URL_EVENT,
  deleteFromLocalStorage,
} from 'config/appConfig'
import {
  setLocalStorage,
  getLocalStorage,
  IS_BROWSER,
  checkMysiteOrPersonalOffer,
  getLiveEventStatus,
  ApiContent,
  convertToBoolean,
} from 'src/utils'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import NuskinDropDownArrowIcon from './NuskinDropDownArrowIcon'
import {
  isEquinoxMysite,
  isEquinoxPOSite,
  isPOHomePage,
} from 'src/utils/mySiteUtils'
import { pageNames } from 'src/routes/pathParams'
import './styles.scss'

@observer
class LocaleModal extends React.Component {
  @observable curLocaleCode

  static contextType = ApiContent
  constructor(props, context) {
    super(props, context)
    this.context = context

    const currentLocaleInLocalStorage = getLocalStorage('defaultLocale') || ''
    const defaultLocale =
      currentLocaleInLocalStorage || APPConfig.getAppConfig().defaultLocale

    const curLocaleFromUrl = getLocaleCodeFromUrl({
      locationProps: props,
      at: 'pathParam',
      defaultLocale: defaultLocale,
      isReverseType: true,
    })

    this.curLocaleCode =
      curLocaleFromUrl || APPConfig.getAppConfig().defaultLocale
  }

  handleClick = (value, at = 'pathParam') => {
    /**
     * @note
     * adding this safer side code, for redirection
     * locale overwriting at storages, cookie and window.APP_CONFIG
     */
    const newLocale = (() => {
      let val = (value.includes('-') ? value.replace('-', '_') : value)?.split(
        '_'
      )
      return {
        ls: [val[0], val[1].toUpperCase()].join('_'),
        cookie: [val[0], val[1].toUpperCase()].join('-'),
        pathParam: `${val[1]}/${val[0]}`.toLowerCase(),
      }
    })()

    const localeFormatForCookie = newLocale.cookie
    const oldPathParam = this.curLocaleCode
      .split('_')
      .reverse()
      .join('/')
      .toLowerCase()

    this.curLocaleCode = newLocale.ls

    if (IS_BROWSER) {
      setLocalStorage('defaultLocale', newLocale.ls)
      setLocalStorage('locale', newLocale.cookie)

      let urlToNavigate = ''
      if (at === 'pathParam') {
        const localeAsPathParam = localeFormatForCookie
          ?.split('-')
          ?.reverse()
          ?.join('/')
          ?.toLowerCase()

        const urlObj = new URL(window.location.href)

        urlToNavigate = `${
          urlObj.pathname === '/'
            ? localeAsPathParam
            : urlObj.pathname.replace(oldPathParam, newLocale.pathParam)
        }`
        if (urlObj?.search) {
          urlToNavigate += urlObj?.search
        }
      } else if (at === 'queryParam') {
        /**
         * @todo
         * !!! if its queryParam
         */
        // urlToNavigate = `${pageNames.home}?locale=${newLocale}`
      }

      deleteFromLocalStorage('subscriptionNextOrderSelectedDate')
      deleteFromLocalStorage('scheduleOrderSelectedDate')

      window.location.href = urlToNavigate
    }
  }

  getLocalLabel = (lcode, localeListObj = {}, isForTitle = false) => {
    const [lang = '', country = ''] = lcode?.split('_') || []

    function convertLanguage(name) {
      const normalizedName = name?.toLowerCase()
      switch (normalizedName) {
        case 'english':
          return 'English'
        case 'french':
          return 'Français'
        case 'chinese':
          return '中文'
        case 'spanish':
          return 'Español'
        case 'vietnamese':
          return 'Tiếng Việt'
        case 'japanese':
          return '日本語'
        case 'korean':
          return '한국어'
        case 'chinese simplified':
          return '中文(简体)'
        case 'chinese traditional':
          return '中文(繁體)'
        case 'finnish':
          return 'Suomi'
        case 'swedish':
          return 'Svenska'
        case 'czech':
          return 'Čeština'
        case 'danish':
          return 'Dansk'
        case 'dutch':
          return 'Nederlands'
        case 'german':
          return 'Deutsch'
        case 'hungarian':
          return 'Magyar'
        case 'italian':
          return 'Italiano'
        case 'norwegian':
          return 'Norsk'
        case 'polish':
          return 'Polski'
        case 'portuguese':
          return 'Português'
        case 'romanian':
          return 'Română'
        case 'slovak':
          return 'Slovenčina'
        default:
          return name || ''
      }
    }
    const { currency = '', name = '' } =
      localeListObj[`${lang}_${country.toUpperCase()}`] || {}

    const countryCodeLocaleModal = convertToBoolean(
      APPConfig?.getAppConfig()?.countryCodeLocaleModal
    )

    const displayCountryCode = country.toUpperCase()
    const displayValue = countryCodeLocaleModal ? displayCountryCode : currency

    if (isForTitle) {
      return `${displayValue} | ${convertLanguage(name)}`
    } else {
      return convertLanguage(name)
    }
  }

  renderDDLocaleItem = (key, localeList, activeLocaleCode) => {
    if (activeLocaleCode === key) {
      return <></>
    }

    return (
      <Dropdown.Item
        onSelect={() => {
          this.handleClick(localeList[key]?.value || '')
        }}
        data-testid={`qa-locale-drop-value-${this.getLocalLabel(
          key,
          localeList,
          false
        )}`}
      >
        {this.getLocalLabel(key, localeList, true)}
      </Dropdown.Item>
    )
  }

  render() {
    const { className = '', isNuskinHeader = false } = this.props

    const currentStoreDataForSSR = this.context?.currentStoreDataForSSR || {}
    const curRegionLocales = IS_BROWSER
      ? APPConfig.getAppConfig().storeData || {}
      : currentStoreDataForSSR

    const title = this.getLocalLabel(this.curLocaleCode, curRegionLocales, true)

    let localModalClassName = `header-language-text align-items-center ${className}`

    if (!isNuskinHeader) {
      localModalClassName += ' d-flex'
    }

    const localeView = Object.keys(curRegionLocales).map((key, index) => {
      return (
        <Fragment key={`locale-dd-${index}`}>
          {this.renderDDLocaleItem(key, curRegionLocales, this.curLocaleCode)}
        </Fragment>
      )
    })

    // console.log('Local Modal >>> title >>> ', {
    //   title,
    //   curLocaleCode: this.curLocaleCode,
    //   defLocale: APPConfig.getAppConfig().defaultLocale,
    //   storeLocale: storeContainer.activeLocale,
    // })
    let contextText = ''
    const enableSelectAnotherRegionForEQMysite = convertToBoolean(
      APPConfig?.getAppConfig()?.enableSelectAnotherRegionForEQMysite
    )
    const enableSelectAnotherRegionForPersonalOffer = convertToBoolean(
      APPConfig?.getAppConfig()?.enableSelectAnotherRegionForPersonalOffer
    )
    const shouldCheckPage =
      (isEquinoxMysite() && enableSelectAnotherRegionForEQMysite) ||
      (isEquinoxPOSite() && enableSelectAnotherRegionForPersonalOffer)
    const currentPath = IS_BROWSER ? window?.location?.pathname || '' : ''
    const isCartOrCheckoutPath =
      currentPath.includes(pageNames.viewCart) ||
      currentPath.includes(pageNames.checkout) ||
      currentPath.includes(pageNames.expressCheckout)
    if (IS_BROWSER) {
      if (shouldCheckPage) {
        if (isCartOrCheckoutPath) {
          contextText = checkMysiteOrPersonalOffer()
        }
      } else {
        contextText = checkMysiteOrPersonalOffer()
      }
    }

    const enableLiveEvent = getLiveEventStatus()
    const regionSelector =
      enableLiveEvent === 'true'
        ? REGION_SELECTOR_URL_EVENT
        : REGION_SELECTOR_URL

    const enableSelectRegion = convertToBoolean(
      APPConfig?.getAppConfig()?.enableRegionSelectorForPOMysite
    )

    // PO-only: viewCart/checkout/expressCheckout always hide
    // "Select another region"; other PO pages honor the
    // enableSelectAnotherRegionForPersonalOffer flag. Non-PO sites are
    // unaffected.
    const hideRegionSelectorForPO =
      isEquinoxPOSite() &&
      (isCartOrCheckoutPath || !enableSelectAnotherRegionForPersonalOffer)

    return (
      <div className="language-container d-flex mr-1">
        <div className={`${!isNuskinHeader && 'row'}`}>
          {!isNuskinHeader && (
            <div>
              <label
                id="Language"
                aria-labelledby="Language"
                className="language-label"
              >
                Language:
              </label>
            </div>
          )}
          <div className={localModalClassName}>
            <Dropdown
              className="language-dropdown"
              data-testid="qa-locale-dropdown"
            >
              <DropdownButton
                variant="none"
                title={
                  isNuskinHeader ? (
                    <>
                      {title}
                      <NuskinDropDownArrowIcon className="nu-dropdown-icon" />
                    </>
                  ) : (
                    title
                  )
                }
                data-testid={`qa-options-${this.getLocalLabel(
                  this.curLocaleCode,
                  curRegionLocales,
                  false
                )}`}
                className={`cost-center-dropdownbutton-wrapper ${
                  isNuskinHeader &&
                  'border locale-dropdown-rounded nu-dropdown-toggle'
                }`}
                bsPrefix={`${isNuskinHeader ? 'py-0 nu-dropdown-button' : ''}`}
              >
                {localeView}
                {(contextText == '' || enableSelectRegion === true) &&
                  enableLiveEvent !== 'true' &&
                  !hideRegionSelectorForPO && (
                    <>
                      {localeView?.length > 1 && <Dropdown.Divider />}
                      <a
                        className="dropdown-item"
                        href={regionSelector}
                        data-testid="qa-locale-drop-value-other"
                      >
                        {i18nTranslate(
                          'selectAnotherRegion',
                          'Select another region',
                          {
                            nameSpace: 'ssr-resource',
                          }
                        )}
                      </a>
                    </>
                  )}
              </DropdownButton>
            </Dropdown>
          </div>
        </div>
      </div>
    )
  }
}

export { LocaleModal }
export default LocaleModal
